import {Popup} from "devextreme-react/popup";
import useMessageType from "../../components/selectbox/type-message";
import useLookUpBase from "../../components/selectbox/LookupBase";
import IMessage from "../../models/IMessage";
import {Button} from "devextreme-react";
import Guid from "../../models/Guid";
import Form, {Label, SimpleItem} from "devextreme-react/form";
import {Lookup} from "devextreme-react/data-grid";
import React, {useState} from "react";

interface IPopupTypeMessageProps {
    onConfirme: (idMessage: Guid) => void
    onClose: () => void,
    idMessageConfirmation?: Guid,
    typeMessage?: 'c' | 'f' | 'e'
}

export const PopupTypeMessage = ({onConfirme, onClose, idMessageConfirmation, typeMessage}: IPopupTypeMessageProps) => {
    const {editorOptions, currentSelectedItem} = useLookUpBase({controllerName: "message", path: `lookup/${typeMessage}`})
    const [selectedIdMessage, setSelectedIdMessage] = useState<{ idMessage?: Guid }>({idMessage: idMessageConfirmation});
    return (
        <Popup
            onHiding={onClose}
            visible={true}
            dragEnabled={true}
            resizeEnabled={true}
            hideOnOutsideClick={false}
            showCloseButton={true}
            showTitle={true}
            dragOutsideBoundary={true}
            title="Confirmation de réservation"
            width={450}
            height={"180"}>
            <div style={{display: "flex", flexDirection: "column", gap: "1rem", width: "100%", justifyContent: "center"}}>
                <Form formData={selectedIdMessage}>
                    <SimpleItem dataField={"idMessage"} editorType={"dxSelectBox"} editorOptions={editorOptions}>
                        <Label text={"Choisir une message à afficher sur la confirmation"}/></SimpleItem>
                </Form>
                <Button style={{alignSelf: "center"}} width={"8rem"} text={"OK"} onClick={() => {
                    onConfirme(currentSelectedItem?.id || Guid.empty)
                }}/>
            </div>
        </Popup>
    );
};
